import { Trans } from "@lingui/macro";
import { IApiEpOrganization } from "@smp/api";
import { UiAvatar, UiButton, UiTypography } from "@smp/ui";
import { testAppendAttr } from "@smp/utils";
import { IconUser } from "@tabler/icons-react";
import { FC, MouseEvent, useCallback, useMemo, useState } from "react";

import { OrganizationRoleIcon } from "@/components/ui/organization_role_icon";
import { useEpOrganizationOrganizationList } from "@/hooks/use_ep_organization";
import { useContextApp } from "@/screens/app/context/app";
import { epOrganizationRoleNameByCodenameGet } from "@/utils";

import classes from "./controls_organization.module.css";
import { MenuOrganization } from "./menu_organization";

export type IControlsOrganizationProps = {
  onChange?: (id: IApiEpOrganization["id"] | null) => void;
};

export const ControlsOrganization: FC<IControlsOrganizationProps> = ({
  onChange,
}) => {
  const [$anchor, set$Anchor] = useState<null | HTMLElement>(null);

  const { organizationList, isOrganizationListLoading } =
    useEpOrganizationOrganizationList();
  const {
    state: { organizationId },
  } = useContextApp();

  const organization = useMemo(
    () =>
      organizationId &&
      organizationList &&
      organizationList.find(
        (organization) => organization.id === organizationId,
      ),
    [organizationId, organizationList],
  );

  const hasOrganizations = useMemo(
    () => organizationList && organizationList.length > 0,
    [organizationList],
  );

  const handleMenuOpen = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    set$Anchor(event.currentTarget);
  }, []);

  const handleMenuClose = useCallback(() => {
    set$Anchor(null);
  }, []);

  if (isOrganizationListLoading) {
    return null;
  }

  return (
    <>
      {hasOrganizations && (
        <>
          <UiButton
            className={classes.button}
            onClick={handleMenuOpen}
            {...testAppendAttr("id", "header_switch_context")}
          >
            {organization ? (
              <>
                <UiAvatar className={classes.button__ava}>
                  <OrganizationRoleIcon codename={organization.role} />
                </UiAvatar>

                <div className={classes.button__content}>
                  <UiTypography className={classes.button__title}>
                    {organization.name}
                  </UiTypography>

                  <UiTypography className={classes.button__subtitle}>
                    {organization.role ? (
                      epOrganizationRoleNameByCodenameGet(organization.role)
                    ) : (
                      <Trans>Owner</Trans>
                    )}
                  </UiTypography>
                </div>
              </>
            ) : (
              <>
                <UiAvatar className={classes.button__ava}>
                  <IconUser />
                </UiAvatar>

                <div className={classes.button__content}>
                  <UiTypography className={classes.button__title}>
                    <Trans>Personal Mode</Trans>
                  </UiTypography>

                  <UiTypography className={classes.button__subtitle}>
                    <Trans>No team chosen</Trans>
                  </UiTypography>
                </div>
              </>
            )}
          </UiButton>

          <MenuOrganization
            $anchor={$anchor}
            marginTop={48}
            onClose={handleMenuClose}
            onChange={onChange}
          />
        </>
      )}
    </>
  );
};
